/**
 * useNarrowScreen — следит за шириной viewport по matchMedia.
 *
 * Используется на дашборде для компактного отображения на узких
 * Android-экранах (Poco X6 Pro и т.п.): сокращение суффикса
 * «USD₮» → «₮», уменьшение кол-ва знаков после точки,
 * адаптивный размер шрифта.
 *
 * Порог по умолчанию — 400px. На iPhone (≥ 390px) верстка стандартная,
 * на узких Android — компактная.
 */
import { useEffect, useState } from 'react';

export function useNarrowScreen(maxWidthPx = 400): boolean {
  const query = `(max-width: ${maxWidthPx}px)`;
  const [isNarrow, setIsNarrow] = useState<boolean>(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const mql = window.matchMedia(query);
    const onChange = (e: MediaQueryListEvent) => setIsNarrow(e.matches);
    mql.addEventListener('change', onChange);
    // Sync initial — на случай рендера до первого match
    setIsNarrow(mql.matches);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return isNarrow;
}
